export enum AtiraLinkCategoryAvailableLangs {
  AR = 'AR',
  TR = 'TR',
}
